"use-strict";

import 'jquery';
import Blazy from '../assets/plugins/blazy/blazy.min';
export class Lazy {

    index = 0;
    clasname = '';
    breakpoints = {};

    constructor(name = 'b-lazy', breakpoints = [
        {
            width: 320,
            src: 'data-src-mobile-small'
        },
        {
            width: 760,
            src: 'data-src-mobile-medium'
        },
        {
            width: 1200,
            src: 'data-src-desktop-medium'
        }
    ]) {
        this.clasname = name;
        this.breakpoints = breakpoints;
        this.init();
        this.startMap();
    }

    startMap() {
        const map = document.getElementById('footer-map');
        setTimeout(()=>{
            const iframe = map.dataset.map;
            map.innerHTML = iframe;
        } , 1500)
    }

    init() {
        const blazy = new Blazy({
            selector: '.' + this.clasname,
            breakpoints: this.breakpoints,
            error: (el) => {
                if (el.dataset.srcLarge !== null && el.dataset.srcLarge !== undefined && el.tagName.toLowerCase() !== 'img') {
                    el.style.backgroundImage = 'url(' + el.dataset.srcLarge + ')';
                    el.classList.add('b-loaded');
                }
                if (el.tagName.toLowerCase() === 'img') {
                    el.src = el.dataset.srcLage !== null ? el.dataset.srcLage : '';
                    el.classList.add('b-loaded');
                }
            }
        });
    }

    static getWidth(){
        /*if (window && window.outerWidth) {
            return window.outerWidth;
        }*/
        return $(window).width();
    }

    static loadImages(){
        const width = Lazy.getWidth();

        $('.lazy-select').each(function(){
            let $el = $(this);
            if (width >= 1400 && $el.data('srcLarge')) {
                Lazy.downloadImage($el, $el.data('srcLarge'));
            } else if (width >= 1200 && $el.data('srcMedium')) {
                Lazy.downloadImage($el, $el.data('srcMedium'));
            } else if (width >= 768 && $el.data('srcSmall')) {
                Lazy.downloadImage($el, $el.data('srcSmall'));
            } else if($el.data('srcTiny')) {
                Lazy.downloadImage($el, $el.data('srcTiny'));
            } else {
                $el.addClass('loaded');
            }
        });

        $('.lazy-img, .lazy-bg').each(function(){
            let $el = $(this);
            let src = $el.data('src');
            let attrSrc = $el.attr('src');
            if (!src) {
                $el.addClass('loaded lazy-no-src');
                return;
            }
            if (attrSrc === src) {
                $el.addClass('loaded lazy-same-src');
                return;
            }
            if (width <= 768 && $el.hasClass('desktop')) {
                $el.addClass('loaded lazy-hide-desktop');
                return;
            }
            Lazy.downloadImage($el, src);
        });
    }

    static bindIndex($el){
        $el.attr('data-lazy-index', Lazy.index);
        Lazy.index++;
    }

    static downloadImage($el, src){
        Lazy.bindIndex($el);
        let handler = new Image();
        handler.onload = () => {
            if ($el.attr('src')) {
                $el.get(0).src = src;
            } else {
                $el.css('background-image', 'url('+src+')');
            }
            $el.addClass('loaded');
        };
        handler.src = src;
    }
}
